<template>
  <div
    aria-live="polite"
    :aria-busy="isLoading"
    class="trek-loading-container relative"
    :class="containerClasses"
    qaid="trek-loading-component"
  >
    <div v-if="!inline" class="trek-loading__content" :class="{invisible: !page && isLoading}">
      <slot />
    </div>
    <transition name="fade">
      <div v-if="isLoading" :class="['trek-loading', {...classes}]">
        <svg
          id="loader-1"
          class="trek-loading__spinner"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          :width="inline ? '1.5em' : '48px'"
          :height="inline ? '1.5em' : '48px'"
          viewBox="0 0 50 50"
          style="enable-background:new 0 0 50 50;"
          xml:space="preserve"
        >
          <path
            fill="currentColor"
            d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z"
          >
            <animateTransform
              attributeType="xml"
              attributeName="transform"
              type="rotate"
              from="0 25 25"
              to="360 25 25"
              dur="0.6s"
              repeatCount="indefinite"
            />
          </path>
        </svg>
        <div v-if="message" class="trek-loading__message" :class="{'ml-1': inline}" v-html="message" />
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    inline: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: '',
    },
    inverse: {
      type: Boolean,
      default: false,
    },
    top: {
      type: Boolean,
      default: false,
    },
    bottom: {
      type: Boolean,
      default: false,
    },
    page: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    classes() {
      return {
        'trek-loading--inline flex items-center': this.inline,
        'flex flex-col items-center justify-center': !this.inline,
        'inset-0': !this.inline && !this.top && !this.bottom,
        'top-0 inset-x-0 mt-2': !this.page && !this.inline && this.top,
        'bottom-0 inset-x-0 mb-2': !this.page && !this.inline && this.bottom,
        'text-white': this.inverse || this.page,
        'trek-loading-container--page-overlay fixed': !this.inline && this.page,
        absolute: !this.inline && !this.page,
      };
    },
    containerClasses() {
      return {
        'trek-loading-container--min-height': !this.inline && !this.page,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/../sass/settings/_settings-colors';
.trek-loading-container--page-overlay {
  background: rgba(map-get($base-palette, 'gray-100'), 0.8);
  z-index: 16000007;
}
.trek-loading-container--min-height,
.trek-loading-container--min-height .trek-loading {
  min-height: 48px;
}
.trek-loading__content {
  opacity: 1;
  transition: opacity 0.4s;
}
.trek-loading__content.invisible {
  opacity: 0;
}
</style>
